import { cn, parseToHtml } from '@finn/ui-utils';
import { capitalize } from 'lodash';
import Link from 'next/link';
import { ElementType } from 'react';

const vocabulary = {
  'alfa-romeo': 'Alfa Romeo',
  vw: 'VW',
  bmw: 'BMW',
  mg: 'MG',
  skoda: 'Škoda',
};

export const Breadcrumbs = ({
  slugArray,
  title,
  heading = 'p',
  tags,
}: {
  heading?: string;
  slugArray: string[];
  title: string;
  tags?: { title: string; slug: string }[];
}) => {
  if (slugArray?.[0] !== 'auto' || slugArray.length <= 2) {
    return null;
  }
  const slugs = slugArray;

  const Heading = heading as ElementType;

  return (
    <nav
      aria-label="breadcrumb"
      className="container my-0 mb-8 ml-auto md:mr-0 md:!w-[calc(100vw-4rem)] md:!max-w-[calc(100vw-4rem)] lg:!w-[calc(50%+630px)] lg:!max-w-[calc(50%+630px)]"
    >
      <ol className="body-14-regular m-0 flex list-none flex-wrap gap-2 p-0 before:!hidden after:!hidden">
        {slugs?.map((slug, index) => {
          const isLast = index === slugs.length - 1;
          const fallbackFromVocabulary = vocabulary[slug];
          const fallbackLabel =
            fallbackFromVocabulary ||
            capitalize(slug)
              ?.replaceAll('-', '&')
              ?.split('&')
              ?.map((item) => capitalize(item))
              ?.join(' & ');
          const label =
            tags?.find(
              (item) => item.slug?.toLowerCase() === slug.toLowerCase()
            )?.title || fallbackLabel;

          return (
            <li key={slug} className="flex gap-2">
              {isLast ? (
                <Heading className="text-steel body-14-regular before:hidden after:hidden">
                  {parseToHtml(title)}
                </Heading>
              ) : (
                <Link
                  className={cn(
                    'whitespace-nowrap',
                    isLast ? 'text-steel' : ''
                  )}
                  href={`/${slugs.slice(0, index + 1).join('/')}`}
                >
                  {label}
                </Link>
              )}
              {!isLast ? <span>-</span> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
